import { z } from 'zod';
import { BaseRubricSchema } from 'libs/end-to-end/src/types/ai-interviewer/base-rubric';

// Question rubric extends base
export const QuestionRubric = BaseRubricSchema.extend({
  question: z.string(),
}).describe('QuestionRubric');

export type QuestionRubric = z.infer<typeof QuestionRubric>;
